import type { PaperUse } from "../../api/types";
import { paperUseLabel, paperUseSentence } from "../../utils/paperUse";

/**
 * G-121 S4 (OD-143): "What is this paper?" — one radio per use, each with the
 * sentence that says what it does. Nothing is picked until the person picks
 * (`value` null): there is no default, the same rule as the IVA side (OD-138).
 */
export function PaperUsePicker({
  name,
  value,
  options,
  onChange,
  disabled = false,
  committed = false,
}: {
  name: string;
  value: PaperUse | null;
  options: readonly PaperUse[];
  onChange: (next: PaperUse) => void;
  disabled?: boolean;
  /** G-164: the paper already became a delivery — "Items only" then means its factura will never come. */
  committed?: boolean;
}) {
  return (
    <div className="paper-use-choices" role="radiogroup" aria-label="What is this paper?">
      {options.map((use) => (
        <label key={use} className="paper-use-choice">
          <input
            type="radio"
            name={name}
            value={use}
            checked={value === use}
            disabled={disabled}
            onChange={() => onChange(use)}
          />
          <span>
            <strong>{paperUseLabel(use)}</strong>
            <small className="muted">{paperUseSentence(use, committed)}</small>
          </span>
        </label>
      ))}
    </div>
  );
}
